/* nuar-quote-me.js — hide sold-out buy buttons when a placeholder (QUOTE-*)
   variant is selected. Price -> "Price on request" + Request a Quote button is
   handled server-side in snippets/product-price.liquid. Deployed by
   scripts/quote-me-cta-deploy.js — remove via --revert. */
(function () {
  var SID = 'nuar-quote-style';
  if (!document.getElementById(SID)) {
    var s = document.createElement('style');
    s.id = SID;
    s.textContent =
      'body.nuar-quote-selected #AddToCart,' +
      'body.nuar-quote-selected .single-add-to-cart-button,' +
      'body.nuar-quote-selected .shopify-payment-button,' +
      'body.nuar-quote-selected #nuar-sticky-btn,' +
      'body.nuar-quote-selected product-form .product-form__buttons{display:none !important;}' +
      '.nuar-quote-btn{display:inline-block;margin-top:10px;}' +
      '.nuar-quote-price .nuar-quote-label{font-weight:600;}';
    document.head.appendChild(s);
  }
  function buildMap(vs) {
    var el = vs.querySelector('script[type="application/json"]');
    if (!el) return null;
    try {
      var m = {};
      JSON.parse(el.textContent).forEach(function (v) { m[v.id] = v.sku || ''; });
      return m;
    } catch (e) { return null; }
  }
  function init() {
    var vs = document.querySelector('variant-selects');
    if (!vs) return;
    var map = buildMap(vs);
    if (!map) return;
    function apply() {
      var input = document.querySelector('[name="id"]');
      var sku = input ? (map[input.value] || '') : '';
      document.body.classList.toggle('nuar-quote-selected', sku.indexOf('QUOTE-') === 0);
    }
    apply();
    var price = document.getElementById('price-' + vs.dataset.section);
    if (price) new MutationObserver(apply).observe(price, { childList: true, subtree: true });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') setTimeout(apply, 60);
    });
    vs.addEventListener('change', function () { setTimeout(apply, 60); });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
